import Tastet from '../tastet.js';

/**
 * Module Template
 */
export default class Template extends Tastet.Module {
  // init ------------------------------------------------------------------------------------------------------------
  init(el, args) {
    args = this.set(args || {}, {
      empty: false,
      typeKey: 'type',
    });

    this.$element = this.$(el);
    this.$parent = this.$element;
    this.empty = true;
    this.templates = this.$element.find('template').map(true, function (t) {
      var id = t.attrs('id') || '*';
      var html = t.html();
      var data = t.data() || {};

      // Get the parent of the template
      this.$parent = t.parent();

      // Remove the current block
      this.utils.dom.remove(t);
      this.empty = false;

      return {
        $id: id,
        $value: {
          data: data,
          html: html,
        },
      };
    });

    var html = this.$parent.html();
    if (html && !this.templates['*']) {
      this.templates['*'] = {
        data: {},
        html: html,
      };
    }

    if (args.empty) {
      this.$parent.html('');
    }
  }

  html(data, type) {
    if (data instanceof Array) {
      return data
        .map(v => {
          return this.html(v, type);
        })
        .join('\n');
    }

    var key = this.get('typeKey');

    if (this.utils.is.str(data)) {
      data = { text: data };
    }

    data = data || {};

    if (!type) {
      type = data[key] || null;
    }

    var tmpl = this.templates[type];
    var html = '';

    // find by other data
    if (!tmpl && type) {
      for (var i in this.templates) {
        var t = this.templates[i];
        if (t.data[key]) {
          var types = this.utils.toArray(t.data[key]);

          if (!~types.indexOf(type)) {
            tmpl = t;
            break;
          }
        }
      }
    }

    tmpl = tmpl || this.templates['*'];

    if (tmpl) {
      html = this.utils.string.replace(tmpl.html || '', data);
    }

    return html;
  }

  render(data, type) {
    if (data) {
      var html = this.html(data, type);
      this.$parent.html(html);
    }
  }

  clear() {
    this.$parent.html('');
  }
}
